"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _common = require("@scuf/common");

var _routes = _interopRequireDefault(require("../common/routes"));

var _Login = _interopRequireDefault(require("./Login"));

var _RequestPasswordReset = _interopRequireDefault(require("./RequestPasswordReset"));

var _ResetPassword = _interopRequireDefault(require("./ResetPassword"));

var _ErrorPage = _interopRequireDefault(require("./ErrorPage"));

var _AppHeader = _interopRequireDefault(require("./AppHeader"));

var _AppFooter = _interopRequireDefault(require("./AppFooter"));

var _AppSessionTimeoutModal = _interopRequireDefault(require("./AppSessionTimeoutModal"));

var _ThirdPartyLicenses = _interopRequireDefault(require("./ThirdPartyLicenses"));

var _PrivateRoute = _interopRequireDefault(require("./PrivateRoute"));

var _UserPreferences = _interopRequireDefault(require("./UserPreferences"));

var _ApplicationContext = require("./ApplicationContext");

var _RegisterNewAccount = _interopRequireDefault(require("./RegisterNewAccount"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var KeystoneApp = /*#__PURE__*/function (_Component) {
  _inherits(KeystoneApp, _Component);

  var _super = _createSuper(KeystoneApp);

  function KeystoneApp(props) {
    var _this;

    _classCallCheck(this, KeystoneApp);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderDefaultContainer", function () {
      var _this$props = _this.props,
          privateRoutes = _this$props.privateRoutes,
          header = _this$props.header,
          Nav = _this$props.nav,
          footer = _this$props.footer;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, header, /*#__PURE__*/_react["default"].createElement(Nav, null, /*#__PURE__*/_react["default"].createElement(_AppSessionTimeoutModal["default"], null), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, privateRoutes, /*#__PURE__*/_react["default"].createElement(_PrivateRoute["default"], {
        exact: true,
        path: _routes["default"].ThirdPartyLicenses,
        component: _ThirdPartyLicenses["default"]
      }), /*#__PURE__*/_react["default"].createElement(_PrivateRoute["default"], {
        exact: true,
        path: _routes["default"].UserPreferences,
        component: _UserPreferences["default"]
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: "/*",
        render: function render() {
          return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
            to: _routes["default"].Login
          });
        }
      }))), footer);
    });

    _this.state = {};
    return _this;
  }

  _createClass(KeystoneApp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var userData = this.context.userData;

      if (userData && userData.response.preferences) {
        var theme = userData.response.preferences.theme;

        if (theme) {
          if (theme === 'light') {
            (0, _common.toggleTheme)(_common.ThemeType.Light);
          }

          if (theme === 'dark') {
            (0, _common.toggleTheme)(_common.ThemeType.Dark);
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          publicRoutes = _this$props2.publicRoutes,
          destination = _this$props2.destination;
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        exact: true,
        path: _routes["default"].Login,
        render: function render(props) {
          return /*#__PURE__*/_react["default"].createElement(_Login["default"], _extends({}, props, {
            // eslint-disable-line react/jsx-props-no-spreading
            destination: destination
          }));
        }
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        exact: true,
        path: _routes["default"].RegisterNewAccount,
        component: _RegisterNewAccount["default"]
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        exact: true,
        path: _routes["default"].RequestPasswordReset,
        component: _RequestPasswordReset["default"]
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        exact: true,
        path: _routes["default"].ResetPassword,
        component: _ResetPassword["default"]
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: _routes["default"].Error,
        component: _ErrorPage["default"]
      }), publicRoutes, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        render: this.renderDefaultContainer
      })));
    }
  }]);

  return KeystoneApp;
}(_react.Component);

KeystoneApp.contextType = _ApplicationContext.AppContext;
KeystoneApp.propTypes = {
  publicRoutes: _propTypes["default"].arrayOf(_propTypes["default"].element).isRequired,
  privateRoutes: _propTypes["default"].arrayOf(_propTypes["default"].element).isRequired,
  header: _propTypes["default"].element,
  nav: _propTypes["default"].element.isRequired,
  footer: _propTypes["default"].element,
  destination: _propTypes["default"].string
};
KeystoneApp.defaultProps = {
  header: /*#__PURE__*/_react["default"].createElement(_AppHeader["default"], null),
  footer: /*#__PURE__*/_react["default"].createElement(_AppFooter["default"], null),
  destination: '/home'
};
var _default = KeystoneApp;
exports["default"] = _default;